const products = {
    title: 'API Products & Automations',
    subtitle: 'Create and manage your API products and automation endpoints',
    createProductButton: 'Create Product',
    productName: 'Product Name',
    name: 'Name',
    category: 'Category',
    status: 'Status',
    description: 'Manage your API product catalog',
    
    // List Page
    searchPlaceholder: 'Search by name or description...',
    filterByStatus: 'Filter by status',
    visibilityFilters: {
      label: 'Filter by visibility',
      all: 'All visibility',
      public: 'Public',
      private: 'Private',
    },
    statusFilters: {
      all: 'All Status',
      active: 'Active',
      draft: 'Draft',
      published: 'Published',
      archived: 'Archived',
      suspended: 'Suspended',
    },
    statuses: {
      active: 'Active',
      draft: 'Draft',
      published: 'Published',
      archived: 'Archived',
      suspended: 'Suspended',
    },
    noProductsFound: 'No products found',
    tryAdjusting: 'Try adjusting your search or filters',
    createFirstProduct: 'Create your first API product to get started',
    version: 'Version',
    endpoints: 'Endpoints',
    totalCalls: 'Total Calls',
    today: 'Today',
    customersLabel: 'Customers',
    productVisibilityLabel: 'Visibility',
    visibilityOptions: {
      public: 'Public',
      private: 'Private',
    },
    visibilityNotes: {
      public: 'Public products are discoverable and allow checkout when active.',
      private: 'Private products require membership or invites. Public checkout is disabled.',
    },
    visibilityWarnings: {
      privateCheckout: 'Private products block public checkout. Customers must have an invite or membership to access APIs.',
      publicCheckout: 'Public products allow checkout once active. Protect sensitive endpoints with authentication.',
    },
    visibilityBadges: {
      public: 'Public',
      private: 'Private',
    },
    
    // Form
    backToProducts: 'Back to Products',
    editProduct: 'Edit Product',
    createNewProduct: 'Create New Product',
    updateConfiguration: 'Update your API product configuration and endpoints',
    configureNewProduct: 'Configure your new API product with endpoints and automation nodes',
    
    // Tabs
    basicInformation: 'Basic Information',
    endpointsTab: 'Endpoints',
    automationNodes: 'Automation Nodes',
    billing: 'Billing',
    
    // Basic Info
    productDetails: 'Product Details',
    defineBasicInfo: 'Define the basic information about your API product',
    productNameLabel: 'Product Name *',
    productNamePlaceholder: 'e.g., Email Automation API',
    descriptionLabel: 'Description *',
    descriptionPlaceholder: 'Describe what your API does and its key features...',
    versionLabel: 'Version *',
    versionPlaceholder: 'Use semantic versioning (e.g., 1.0.0)',
    typeTag: 'Type a tag and press Enter',
    
    // Security
    securityRateLimiting: 'Security & Rate Limiting',
    configureAuth: 'Configure authentication and rate limits for your API',
    authenticationType: 'Authentication Type',
    rateLimits: 'Rate Limits',
    requestsPerMinute: 'Requests per Minute',
    requestsPerHour: 'Requests per Hour',
    requestsPerDay: 'Requests per Day',
    
    // Endpoints
    apiGatewayEndpoints: 'API Gateway Endpoints',
    registerEndpoints: 'Register your API endpoints to create gateway endpoints that customers will use',
    addEndpoint: 'Add Endpoint',
    syncEndpoint: 'Sync endpoint',
    removeEndpointFromGateway: 'Remove from gateway',
    noEndpointsYet: 'No endpoints yet',
    addEndpointsDescription: "Add endpoints to define your API's functionality",
    addFirstEndpoint: 'Add First Endpoint',
    method: 'Method',
    path: 'Path',
    rateLimit: 'Rate Limit',
    syncStatus: 'Sync Status',
    gateway: 'Gateway:',
    perMin: '/min',
    syncToApisix: 'Sync to APISIX',
    
    // Endpoint Dialog
    editEndpoint: 'Edit Endpoint',
    addNewEndpoint: 'Add New Endpoint',
    mapEndpoint: 'Map your API endpoint to a gateway path that customers will use',
    yourApiEndpointUrl: 'Your API Endpoint URL',
    endpointUrlPlaceholder: 'https://your-api.com/v1/emails/send',
    actualEndpointDescription: 'The actual endpoint in your API that will be called',
    generatedGatewayPath: 'Generated Gateway Path',
    gatewayPathPlaceholder: '/api/v1/provider/your-product/emails/send',
    gatewayPathDescription: 'The path customers will use to access this endpoint through your API gateway',
    rateLimitPerMinute: 'Rate Limit (requests per minute)',
    whatDoesEndpointDo: 'What does this endpoint do?',
    updateEndpoint: 'Update Endpoint',
    
    // Automation
    automationNodesTitle: 'Automation Nodes',
    automationDescription: 'Register node IDs for automation platforms. Nodes will provide their own configuration.',
    generateNodeId: 'Generate Node ID',
    generateAnotherNodeId: 'Generate Another Node ID',
    noAutomationNodes: 'No automation nodes yet',
    createNodes: 'Create nodes to enable automation platform integrations',
    generateFirstNodeId: 'Generate First Node ID',
    runs: 'runs',
    platform: 'Platform',
    billingType: 'Billing Type',
    perRun: 'Per Run',
    perTime: 'Per Time',
    perData: 'Per Data',
    creditsPerRun: 'credits/run',
    creditsPerMin: 'credits/min',
    creditsPerMb: 'credits/MB',
    waitingForConfig: 'Waiting for node configuration',
    nodeWillSendConfig: 'The automation node will send its configuration when it connects',
    integrationInstructions: 'Integration Instructions:',
    useNodeId: 'Use this Node ID in your automation platform to connect to this product. The node will automatically send its billing configuration.',
    activate: 'Activate',
    deactivate: 'Deactivate',
    
    // Billing
    billingModel: 'Billing Model',
    billingConfiguration: 'Billing Configuration',
    billingConfigurationDescription: 'Configure how customers will be charged for using this API product',
    chooseBillingModel: 'Choose how customers will be charged for using this API product',
    combineBillingModels: 'Combine multiple billing models',
    combineBillingModelsDescription: 'You can enable multiple billing models simultaneously. For example, offer subscriptions with included credits and allow additional credit purchases.',
    planTypes: 'Plan Types',
    individualPlans: 'Individual Plans',
    individualPlansDescription: 'Plans designed for individual users and small teams',
    individualPlansConfiguration: 'Individual Plans Configuration',
    individualPlansConfigDescription: 'Configure billing options for individual customers',
    teamsPlans: 'Teams Plans',
    teamsPlansDescription: 'Plans designed for organizations and larger teams with multiple seats',
    teamsPlansConfiguration: 'Teams Plans Configuration',
    teamsPlansConfigDescription: 'Configure billing options for team customers with multiple seats',
    subscriptionBased: 'Subscription-based',
    subscriptionBasedPricing: 'Subscription-based Pricing',
    subscriptionDescription: 'Customers pay a recurring fee for access to your API with defined usage limits',
    individualSubscriptionDescription: 'Individual customers pay a recurring fee for API access',
    teamsSubscriptionDescription: 'Teams pay recurring fees with multiple seats and shared access',
    subscriptionOptions: 'Subscription Options',
    usageBased: 'Usage-based (Credits)',
    usageDescription: 'Customers purchase credits and pay per API call or resource usage',
    individualUsageDescription: 'Individual customers purchase credits for API usage',
    teamsUsageDescription: 'Teams purchase shared credits that can be used by any team member',
    oneTimePayment: 'One-time Payment',
    oneTimeDescription: 'Customers pay once for lifetime access to your API',
    individualOneTimeDescription: 'Individual customers pay once for lifetime access',
    teamsOneTimeDescription: 'Teams pay once for lifetime access with multiple seats',
    editPlan: 'Edit Plan',
    configurePlan: 'Configure',
    oneTimeIndividualNotice: 'Only one one-time payment plan is allowed for individual customers.',
    
    // Subscription Plans
    subscriptionPlans: 'Subscription Plans',
    subscriptionPlansDescription: 'Define different tiers with varying features and limits',
    addPlan: 'Add Plan',
    newPlan: 'New Plan',
    plan: 'Plan',
    recommended: 'Recommended',
    popular: 'Popular',
    planName: 'Plan Name',
    planNamePlaceholder: 'Enter plan name',
    packageName: 'Package Name',
    packageNamePlaceholder: 'e.g., 10K Credits',
    planNamePlaceholderExample: 'e.g., Professional',
    briefDescription: 'Brief description',
    pricingByBillingCycle: 'Pricing by Billing Cycle',
    teamSettings: 'Team Settings',
    price: 'Price',
    basePrice: 'Base Price',
    billingCycle: 'Billing Cycle',
    monthly: 'Monthly',
    yearly: 'Yearly',
    quarterly: 'Quarterly',
    semiAnnual: 'Semi-Annual',
    biennial: 'Biennial',
    features: 'Features',
    featurePlaceholder: 'Enter feature description',
    addFeature: 'Add Feature',
    listFeaturesDescription: 'List the features included in this plan that will be shown to customers',
    addFeaturePlaceholder: 'Add a new feature...',
    includedFeatures: 'Included Features',
    translateFeatures: 'Translate Features',
    translateFeaturesDescription: 'Provide translations for your product features in different languages.',
    feature: 'Feature',
    original: 'Original',
    noAdditionalLanguages: 'No additional languages configured. Please add languages in the product overview.',
    translationProgress: 'Translation Progress',
    perMonth: '/month',
    includedSeats: 'Included Seats',
    pricePerAdditionalSeat: 'Price per Additional Seat',
    numberOfTeamMembersIncluded: 'Number of team members included in the base price',
    allowAdditionalSeats: 'Allow additional seats',
    includeCreditsInPlan: 'Include credits in this plan',
    includedCredits: 'Included Credits',
    additionalCreditPrice: 'Additional Credit Price',
    pricePerAdditionalCredit: 'Price per additional credit',
    markAsRecommended: 'Mark as recommended',
    stripeIntegration: 'Stripe Integration',
    stripeProductId: 'Stripe Product ID',
    stripePriceId: 'Stripe Price ID',
    stripeIdsDescription: 'Enter your Stripe Product and Price IDs from your Stripe dashboard',
    
    // Credit Pricing
    creditPricing: 'Credit Pricing',
    creditPricingDescription: 'Set the base price per credit and define credit packages',
    pricePerCredit: 'Price per Credit',
    minimumPurchase: 'Minimum Purchase',
    minimumCreditsPerPurchase: 'Minimum credits per purchase',
    creditPackages: 'Credit Packages',
    addPackage: 'Add Package',
    credits: 'credits',
    for: 'for',
    off: 'off',
    perCredit: 'per credit',
    credit: 'credit',
    month: 'month',
    year: 'year',
    seat: 'seat',
    seats: 'seats',
    perSeat: 'per seat',
    perMinSuffix: '/min',
    perHourSuffix: '/hr',
    perDaySuffix: '/day',
    forIndividuals: 'For Individuals',
    forTeams: 'For Teams',
    preview: 'Preview',
    previewIndividualPlaceholder: 'Activate subscription or credit models to preview individual pricing cards.',
    previewTeamsPlaceholder: 'Enable team plans to preview how multi-seat pricing appears to customers.',
    includes: 'Includes',
    additionalCredits: 'Additional credits',
    additionalSeat: 'Additional seat',
    seatsIncluded: 'seats included',
    teamCredits: 'team credits',
    teamSubscriptionPlans: 'Team Subscription Plans',
    teamCreditPackages: 'Team Credit Packages',
    sharedCreditsDescription: 'Credits are shared among all team members',
    teamOneTimePayment: 'Team One-time Purchase',
    monthsAccess: 'months access',
    selectForTeam: 'Select for Team',
    purchaseForTeam: 'Purchase for Team',
    noPlanTypesEnabled: 'Please enable at least one plan type to see pricing options',
    newPackage: 'New Package',
    removeFeature: 'Remove feature',
    removePlan: 'Remove Plan',
    effectivePrice: 'Effective price',
    configureCredits: 'Configure Credits',
    billingExample: 'Billing Example',
    totalCost: 'Total cost',
    sharedCredits: 'Shared Credits',
    teamMinimumPurchase: 'Team Minimum Purchase',
    autoTopup: 'Auto Top-up',
    autoTopupDescription: 'Allow customers to automatically purchase credits when running low',
    
    // One-time Payment
    oneTimePaymentConfig: 'One-time Payment Configuration',
    oneTimePaymentDescription: 'Set a single price for lifetime access to this API product',
    lifetimeAccess: 'Customers pay once and get lifetime access',
    oneTimePrice: 'One-time Price',
    accessDuration: 'Access Duration (months)',
    teamSeats: 'Team Seats',
    pricePerSeat: 'Price per Additional Seat',
    
    // Payment Integration
    paymentIntegration: 'Payment Integration',
    paymentIntegrationDescription: 'Connect your Stripe account to process payments',
    stripeLabel: 'Stripe',
    connected: 'Connected',
    notConnected: 'Not connected',
    stripeSettings: 'Settings',
    stripeConnectedInfo: 'Your Stripe account is connected. Customers will be redirected to Stripe Checkout for secure payment processing.',
    platformFee: 'Platform fee: 2.9% + $0.30 per transaction',
    connectStripe: 'Connect Stripe',
    configurePricing: 'Configure Pricing',
    archive: 'Archive',
    delete: 'Delete',
    overview: 'Overview',
    featureFlags: 'Feature Flags',
    selectFeaturesForPlan: 'Select which features are included in this plan',
    optional: 'Optional',
    pressEnterToAddTags: 'Press Enter or use comma to add tags',
    translationDescription: 'Provide translations for different languages to make your product accessible globally',
    enterTranslation: 'Enter {{language}} translation',
    manageTranslations: 'Manage translations',
    analytics: {
      title: 'Operations Analytics',
      subtitle: 'View usage analytics and performance metrics',
      comingSoon: 'Analytics dashboard coming soon...'
    },
    
    // Product Overview Tab
    productInformation: 'Product Information',
    basicDetailsAboutProduct: 'Basic details about your API product',
    draft: 'Draft',
    published: 'Published',
    archived: 'Archived',
    suspended: 'Suspended',
    loadingName: 'Loading...',
    loadingDescription: 'Loading description...',
    authentication: 'Authentication',
    authTypes: {
      apiKey: 'API Key',
      oauth2: 'OAuth 2.0',
      bearer: 'Bearer Token',
      basic: 'Basic Auth',
    },
    perMinute: 'Per Minute',
    perHour: 'Per Hour',
    perDay: 'Per Day',
    usageStatistics: 'Usage Statistics',
    currentUsageMetrics: 'Current usage metrics for this product',
    last24Hours: 'Last 24 Hours',
    activeCustomers: 'Active Customers',
    
    // Product Endpoints Tab
    configureEndpoints: 'Configure your API endpoints and map them to gateway paths',
    syncToGateway: 'Sync to Gateway',
    gatewayPath: 'Gateway Path',
    originalUrl: 'Original URL',
    methods: 'Methods',
    copyGatewayUrl: 'Copy gateway URL',
    testEndpoint: 'Test endpoint',
    deleteEndpoint: 'Delete endpoint',
    noEndpointsConfigured: 'No endpoints configured yet',
    publicPathDescription: 'The public path customers will use to access this endpoint',
    yourActualApiEndpoint: 'Your actual API endpoint URL',
    httpMethods: 'HTTP Methods',
    rateLimitsOptional: 'Rate Limits (Optional)',
    descriptionOptional: 'Description (Optional)',
    describeEndpoint: 'Describe what this endpoint does',
    editApiEndpoint: 'Edit API Endpoint',
    updateEndpointConfiguration: 'Update the configuration for this endpoint',
    testApiEndpoint: 'Test API Endpoint',
    testEndpointDescription: 'Test your endpoint through the provider gateway',
    gatewayUrl: 'Gateway URL',
    gatewayUrlExample: '{{base}}{{path}}',
    httpMethod: 'HTTP Method',
    useTestApiKey: 'Use test API key',
    enterApiKey: 'Enter API key',
    headers: 'Headers',
    addHeader: 'Add Header',
    headerName: 'Header name',
    headerValue: 'Header value',
    requestBody: 'Request Body',
    testing: 'Testing...',
    executeTest: 'Execute Test',
    response: 'Response',
    responseTimeMs: '{{time}}ms',
    body: 'Body',
    close: 'Close',
    
    // Product Automation Nodes Tab
    generateNodeIds: 'Generate unique node IDs for automation platform integrations',
    addNode: 'Add Node',
    nodeId: 'Node ID',
    created: 'Created',
    copyNodeId: 'Copy node ID',
    editNodeName: 'Edit node name',
    deleteNode: 'Delete node',
    noAutomationNodesCreated: 'No automation nodes created yet',
    integrationInstructionsDescription: 'Follow these steps to integrate automation nodes',
    integrationStep1: 'Click "Add Node" to generate a unique node ID',
    integrationStep2: 'Give the node a descriptive name for your reference',
    integrationStep3: 'Copy the generated node ID',
    integrationStep4: 'Configure the node ID in your automation platform (Make.com, Zapier, etc.)',
    integrationStep5: 'The node will automatically report its usage for billing',
    important: 'Important:',
    automationNodesCalculate: 'Automation nodes calculate their own credit usage based on the operations they perform. No additional configuration is needed in the portal.',
    createAutomationNode: 'Create Automation Node',
    createNodeDescription: 'Generate a unique node ID for automation platform integration',
    nodeName: 'Node Name',
    nodeNamePlaceholder: 'e.g., Email Processor, Data Transformer',
    chooseNodeName: 'Choose a descriptive name to help you identify this node',
    createNode: 'Create Node',
    editAutomationNode: 'Edit Automation Node',
    editNodeDescription: 'Update the name of this automation node',
    nodeIdReadOnly: 'Node ID (Read-only)',
    updateNode: 'Update Node',
    nodeTypeLabel: 'Node Type',
    nodeType: {
      billing: 'Billing',
      report: 'Report',
      billingDescription: 'Reports credit usage for billing purposes',
      reportDescription: 'Sends text messages for error reporting and status updates'
    },
    
    // Language Configuration
    supportedLanguages: 'Supported Languages',
    supportedLanguagesDescription: 'Select which languages this product will support for translations',
    addLanguage: 'Add Language',
    languageSelectorHint: 'English is always included as the default language. Select additional languages to enable translations.',
    selectLanguage: 'Select Language',
    selectLanguageDescription: 'Choose a language to add to your product',
    
    // Currency Configuration
    currencyConfiguration: 'Currency Configuration',
    manageCurrenciesDescription: 'Manage the currencies available for this product\'s pricing',
    activeCurrencies: 'Active Currencies',
    addCurrency: 'Add Currency',
    defaultCurrencyInfo: 'The default currency is used when customer location cannot be detected. All prices must be defined for all active currencies.',
    defaultBadgeLabel: 'Default',
    selectCurrencyToAdd: 'Select a currency to add to this product',
    searchCurrencies: 'Search currencies...',
    noCurrenciesFound: 'No currencies found',
    pricingEditor: {
      toastLoadError: 'Failed to load pricing data',
      saving: 'Saving…',
      lastSaved: 'Last saved: {{time}}',
      pendingChanges: 'Changes pending…',
      fillAllPrices: 'All currencies must have prices defined. Please fill in all price fields.',
      loadError: 'Failed to load pricing data. Please try refreshing the page.',
      discountBadge: '{{value}}% discount',
      pricePlaceholder: '0.00',
      monthlyEquivalent: 'Monthly Equivalent',
      monthlyPrice: '{{price}} per month',
      upfrontPaymentNote: 'Customer pays {{months}} months upfront',
      pricingSummaryTitle: 'Pricing Summary',
      currencySummaryLabel: '{{currency}}:',
      cycleSummaryLabel: '{{cycle}}:',
      discountSuffix: '(-{{value}}%)',
    },
    stripe: {
      title: 'Stripe Configuration',
      description: 'Configure your Stripe account to accept customer payments',
      badgeLive: 'Live Mode',
      badgeTest: 'Test Mode',
      testConnection: 'Test Connection',
      mode: {
        live: 'Live',
        test: 'Test',
      },
      statusConfigured: 'Stripe account configured ({{mode}} mode)',
      configuredOn: '• Configured on {{date}}',
      viewDashboard: 'View Dashboard',
      accountCapabilities: 'Account Capabilities',
      actionRequired: 'Action Required:',
      completeRequirements: 'Please complete these requirements in your',
      dashboardLink: 'Stripe Dashboard',
      apiKeysSection: 'Stripe API Keys',
      environmentLabel: 'Environment',
      testMode: 'Test Mode',
      liveMode: 'Live Mode',
      recommendedBadge: 'Recommended',
      productionBadge: 'Production',
      environmentDescription: 'Start with test mode to safely configure and test your setup before going live.',
      publishableKeyLabel: 'Publishable Key',
      publishableKeyDescriptionConfigured: 'Leave empty to keep current key, or enter a new key to update.',
      publishableKeyDescription: 'Found in your Stripe Dashboard → Developers → API Keys.',
      secretKeyLabel: 'Secret Key',
      secretKeyDescriptionConfigured: 'Leave empty to keep current key, or enter a new key to update.',
      secretKeyDescription: 'Secret key from your Stripe Dashboard.',
      webhookSecretLabel: 'Webhook Secret',
      optionalLabel: '(Optional)',
      webhookDescription: 'For webhook signature verification (recommended for production).',
      accountSettingsSection: 'Account Settings',
      countryLabel: 'Country',
      currencyLabel: 'Currency',
      validateKeys: 'Validate Keys',
      saveConfiguration: 'Save Configuration',
      removeConfiguration: 'Remove Configuration',
      helpHeading: 'How to get your Stripe API keys:',
      helpSteps: [
        'Go to',
        'Navigate to Developers → API Keys',
        'Copy your Publishable key and Secret key',
        'For webhooks, go to Developers → Webhooks and copy the signing secret',
      ],
      individualAccountsHeading: 'Individual Stripe accounts',
      individualAccountsNote: 'allow you to keep 100% of customer payments with direct Stripe dashboard access.',
    },
    subscriptionPlanEditor: {
      dialogTitleIndividual: 'Configure Subscription Plan',
      dialogTitleTeam: 'Configure Team Subscription Plan',
      dialogDescriptionIndividual: 'Set up pricing and features for this plan',
      dialogDescriptionTeam: 'Set up pricing and features for this team plan',
      nameLabel: 'Plan Name',
      namePlaceholder: 'e.g., Professional',
      descriptionLabel: 'Description (Optional)',
      descriptionPlaceholder: 'Brief description',
      pricingByCycleTitle: 'Pricing by Billing Cycle',
      pricingWarning: 'All currencies must have prices defined. Please fill in all price fields.',
      pricingInfo: 'All currencies must have prices defined for each billing cycle.',
      recurringPriceHelper: 'Price after intro period.',
      introToggleLabel: 'Intro price (optional)',
      introSectionTitle: 'Intro price',
      introPriceHelper: 'Promotional price for the first N billing cycles.',
      introPricePlaceholder: '0.00',
      introCyclesLabel: 'Apply intro price for N billing cycles',
      introCyclesHelper: 'Number of cycles the intro price applies to.',
      introHigherWarning: 'Intro price is higher than the recurring price.',
      introSummary: 'Intro: {{introPrice}} for {{cycles}} billing cycles, then {{recurringPrice}}',
      monthlyEquivalentLabel: 'Monthly Equivalent',
      monthlyEquivalentValue: '{{price}} per month',
      teamSettingsTitle: 'Team Settings',
      teamSettingsDescription: 'Configure seat allocation and pricing for team plans',
      includedSeatsLabel: 'Included Seats',
      includedSeatsPlaceholder: 'Enter seat count',
      includedSeatsHelper: 'Number of team members included in the base price',
      allowAdditionalSeatsLabel: 'Allow additional seats',
      pricePerSeatLabel: 'Price per Additional Seat',
      pricePerSeatDescription: 'Cost for each team member beyond included seats',
      pricePlaceholder: '0.00',
      includeCreditsLabel: 'Include credits in this plan',
      creditsInfo: 'Credits are granted every month, regardless of the customer’s payment schedule.',
      creditsPerCycleLabel: 'Credits per month',
      creditsPerCyclePlaceholder: '1000',
      allowTopUpLabel: 'Allow credit top-up',
      topUpPriceLabel: 'Price per additional credit',
      topUpPriceDescription: 'Cost for each additional credit when customers top up',
      additionalSettingsTitle: 'Additional Settings',
      visibleToCustomersLabel: 'Visible to customers',
      recommendedLabel: 'Mark as recommended plan',
      freeTrialLabel: 'Offer free trial',
      freeTrialDaysLabel: 'Free trial period (days)',
      trialRequiresCardLabel: 'Require card for trial',
      trialBeforeIntro: 'Trial happens before intro pricing.',
      featureFlagsTitle: 'Feature Flags',
      featureFlagsDescription: 'Select which feature flags activate for this plan',
      featuresTitle: 'Features',
      featuresDescription: 'List the features included in this plan that will be shown to customers',
      featurePlaceholder: 'Add a new feature...',
      featuresCount: '{{count}} feature(s) added',
      noFeatures: 'No features added yet',
      saveButton: 'Save Plan',
      translationNameLabel: 'Plan Name',
      translationDescriptionLabel: 'Plan Description',
      validation: {
        nameRequired: 'Plan name is required',
        nameMin: 'Plan name must be at least 3 characters',
        nameMax: 'Plan name must be less than 100 characters',
        priceForCurrency: 'Price required for {{currency}}',
        introPriceForCurrency: 'Intro price required for {{currency}}',
        introCyclesMin: 'Intro cycles must be at least 1',
        topUpPriceForCurrency: 'Top-up price required for {{currency}}',
      },
      toasts: {
        updateSuccess: 'Subscription plan updated successfully',
        createSuccess: 'Subscription plan created successfully',
        duplicateName: 'A plan with this name already exists. Please choose a different name.',
        saveError: 'Failed to save subscription plan',
        fixValidation: 'Please fix the validation errors',
      },
    },
    subscriptionPricingCard: {
      monthlyLabel: 'Monthly:',
      monthlyValue: '{{price}}/month',
      annualLabel: 'Annual:',
      annualValue: '{{price}}/year',
      annualSummary: '({{price}}/month - {{discount}}% discount)',
      includedSeats: '{{count}} seats included',
      additionalSeat: '{{price}}/additional seat',
      featuresTitle: 'Included Features:',
    },
    translationFeaturesList: {
      maxFeatures: 'Max {{count}} features',
      featurePlaceholder: 'Feature {{index}}',
      addPlaceholder: 'Add a feature',
      defaultLanguageNote: 'Features in the default language will be used as reference for other translations.',
      missingFeatures: '{{count}} features missing compared to default language.',
    },
    translationInput: {
      percentTranslated: '{{value}}% translated',
      completenessLabel: 'Translation completeness: {{value}}%',
      languageCoverage: '{{translated}} of {{total}} languages',
      defaultPlaceholder: 'Enter {{label}} in {{language}}',
      defaultLanguageNote: 'This is the default language. It will be used as fallback if translations are missing.',
    },
    devTools: {
      triggerLabel: 'Dev Tools',
      title: 'Development Tools',
      description: 'Configure data sources and simulate network conditions for development',
      tabs: {
        datasource: 'Data Source',
        network: 'Network',
        debug: 'Debug',
      },
      datasource: {
        title: 'Data Source Configuration',
        description: 'Switch between mock and live API data',
        useMock: 'Use Mock Data',
        mockLabel: 'Mock',
        liveLabel: 'Live',
        networkDelay: 'Network Delay: {{value}}ms',
        logCalls: 'Log API Calls',
      },
      network: {
        title: 'Network Simulation',
        description: 'Test different network conditions',
        fast: 'Fast',
        normal: 'Normal',
        slow: 'Slow',
        unreliable: 'Unreliable',
      },
      debug: {
        title: 'Debug Tools',
        description: 'Debug and inspect application state',
        logConfig: 'Log Current Config',
        inspectApi: 'Inspect API Client',
        exportConfig: 'Export Configuration',
        clearCache: 'Clear Cache & Reload',
        info: {
          apiUrl: 'API URL',
          environment: 'Environment',
          dataSource: 'Data Source',
          mockDelay: 'Mock Delay: {{value}}ms',
        },
      },
      debugEnv: {
        envLabel: 'VITE_USE_MOCK_DATA env',
        parsedBoolean: 'Parsed as boolean',
        configSource: 'Config source',
        isUsingMock: 'isUsingMockData()',
      },
      mockIndicator: {
        delayBadge: '{{value}}ms delay',
        title: 'Mock Data Active',
        description: 'Using simulated API responses for development',
        delayDetail: 'Delay: {{value}}ms',
        logging: 'Logging: {{state}}',
        on: 'On',
        off: 'Off',
        consoleHint: 'Click to view config in console',
      },
    },
    createProduct: {
      title: 'Create New Product',
      subtitle: 'Enter basic information to create your product. You can add more details after creation.',
      nameLabel: 'Product Name',
      namePlaceholder: 'e.g., Email Automation API',
      descriptionLabel: 'Description (Optional)',
      descriptionPlaceholder: 'Brief description of your API product...',
      draftInfo: 'Your product will be created as a',
      draftLabel: 'draft',
      draftFollowup: 'You can configure endpoints, billing, and other settings after creation.',
      creatingLabel: 'Creating...',
      submitLabel: 'Create & Continue',
      validation: {
        nameRequired: 'Product name is required',
      },
      errorMessage: 'Failed to create product. Please try again.',
    },
    subscriptionPlansList: {
      loadError: 'Failed to load subscription plans. Please try refreshing the page.',
      emptyTitle: 'No subscription plans yet',
      emptyDescription: 'Create your first subscription plan to get started',
      variantsTitle: 'Variants',
      addVariant: 'Add variant',
      variantsEmpty: 'No variants yet. Create a variant to offer alternative pricing or terms.',
      defaultBadge: 'Default',
      hiddenBadge: 'Hidden',
      visibilityAll: 'All',
      visibilityVisible: 'Visible',
      visibilityHidden: 'Hidden',
      showVariants: 'Show variants ({{count}})',
      hideVariants: 'Hide variants ({{count}})',
      deletePlan: 'Delete plan',
      deleteTitle: 'Delete subscription plan',
      deleteDescription: 'This will permanently delete the plan. This action cannot be undone.',
      deleteConfirm: 'Delete plan',
      deleteBlockedVariants: 'Delete variants before deleting this plan.',
    },
    subscriptionPlanVariants: {
      dialogTitle: 'Add plan variant',
      dialogDescription: 'Create a variant of "{{name}}" with optional overrides.',
      nameLabel: 'Variant name',
      namePlaceholder: 'e.g., Starter - Student',
      descriptionLabel: 'Description (Optional)',
      descriptionPlaceholder: 'Student pricing',
      overridePricingLabel: 'Override pricing',
      overridePricingHelper: 'Leave pricing empty to inherit the base plan.',
      overrideTrialLabel: 'Override trial settings',
      trialDaysLabel: 'Free trial days',
      trialRequiresCardLabel: 'Require card for trial',
      overrideSeatsLabel: 'Override team seats',
      overrideSeatsHelper: 'Leave fields blank to inherit from the base plan.',
      minSeatsLabel: 'Minimum seats',
      minSeatsPlaceholder: 'Optional minimum',
      maxSeatsLabel: 'Maximum seats',
      maxSeatsPlaceholder: 'Optional maximum',
      overrideCreditsLabel: 'Override credits',
      includeCreditsLabel: 'Include credits in this variant',
      creditsPerCycleLabel: 'Credits per month',
      allowTopUpLabel: 'Allow credit top-up',
      topUpPriceLabel: 'Price per additional credit',
      overrideFeatureFlagsLabel: 'Override feature flags',
      featureFlagsHelper: 'Select which feature flags are enabled for this variant.',
      featureFlagsEmpty: 'No feature flags available yet.',
      pricingEmptyError: 'Add pricing for at least one billing cycle, or turn off pricing overrides.',
      seatsEmptyError: 'Add at least one seat override, or turn off seat overrides.',
      seatsInvalidError: 'Enter a whole number of at least 1.',
      saveButton: 'Create variant',
      savingLabel: 'Creating variant...',
      cancelButton: 'Cancel',
    },
    oneTimePlan: {
      toastSaveError: 'Failed to save one-time plan. Please check the console for details.',
      dialogTitle: 'Configure One-Time Payment',
      dialogDescription: 'Set up pricing and features for this plan',
      nameLabel: 'Plan Name',
      namePlaceholder: 'e.g., Professional',
      descriptionLabel: 'Description (Optional)',
      descriptionPlaceholder: 'Brief description',
      priceSectionTitle: 'One-Time Payment Price',
      priceSectionDescription: 'Price for permanent or time-limited access',
      pricePlaceholder: '0.00',
      accessDurationTitle: 'Access Duration',
      monthsLabel: 'months',
      unlimitedAccessLabel: 'Unlimited access',
      featuresTitle: 'Features',
      featuresDescription: 'List the features included in this plan that will be shown to customers',
      featurePlaceholder: 'Add a new feature...',
      featureFlagsTitle: 'Feature Flags',
      featureFlagsDescription: 'Select which features are included in this plan',
      additionalSettingsTitle: 'Additional Settings',
      recommendedLabel: 'Mark as recommended plan',
      freeTrialLabel: 'Offer free trial',
      freeTrialDaysLabel: 'Free trial period (days)',
      saveButton: 'Save Plan',
      translationNameLabel: 'Plan Name',
      translationDescriptionLabel: 'Plan Description',
      validation: {
        nameRequired: 'Plan name is required',
        pricesRequired: 'All currencies must have prices defined',
      },
    },
    oneTimePlanList: {
      loadError: 'Failed to load one-time plans. Please try refreshing the page.',
      emptyTitle: 'No one-time plans yet',
      emptyDescription: 'Create your first one-time payment plan to get started',
      confirmArchive: 'Are you sure you want to archive "{{name}}"? Existing purchases will remain valid.',
      confirmDelete: 'Are you sure you want to permanently delete "{{name}}"? This action cannot be undone.',
      copyName: '{{name}} (Copy)',
      monthlyEquivalent: '~{{price}}/mo',
      lifetimeAccess: 'Lifetime Access',
      teamsLabel: 'Teams',
      individualLabel: 'Individual',
      includedSeats: 'Included seats: {{count}}',
    },
    creditPackage: {
      toastSaveError: 'Failed to save credit package. Please check the console for details.',
      dialogTitle: 'Configure Credit Package',
      dialogDescription: 'Set up pricing and features for this credit package',
      nameLabel: 'Package Name',
      namePlaceholder: 'e.g., 10k Credits',
      descriptionLabel: 'Description (Optional)',
      descriptionPlaceholder: 'Brief description',
      creditsLabel: 'Number of Credits',
      creditsHelper: 'Total credits included in this package',
      priceSectionTitle: 'Package Price',
      priceSectionDescription: 'One-time price for this credit package',
      pricePlaceholder: '0.00',
      featuresTitle: 'Features',
      featuresDescription: 'List the features included in this package that will be shown to customers',
      featurePlaceholder: 'Add a new feature...',
      featureFlagsTitle: 'Feature Flags',
      featureFlagsDescription: 'Select which features are included in this package',
      additionalSettingsTitle: 'Additional Settings',
      recommendedLabel: 'Mark as recommended package',
      freeTrialLabel: 'Offer free trial',
      freeTrialDaysLabel: 'Free trial period (days)',
      requireCardLabel: 'Require credit card for trial',
      saveButton: 'Save Package',
      translationNameLabel: 'Package Name',
      translationDescriptionLabel: 'Package Description',
      validation: {
        nameRequired: 'Package name is required',
        creditsRequired: 'Number of credits must be greater than 0',
        pricesRequired: 'All currencies must have prices defined',
        priceForCurrency: 'Price required for {{currency}}',
      },
    },
    creditPackageList: {
      loadError: 'Failed to load credit packages. Please try refreshing the page.',
      emptyTitle: 'No credit packages yet',
      emptyDescription: 'Create your first credit package to get started',
      confirmArchive: 'Are you sure you want to archive "{{name}}"? Existing purchases will remain valid.',
      confirmDelete: 'Are you sure you want to permanently delete "{{name}}"? This action cannot be undone.',
      copyName: '{{name}} (Copy)',
      packagePriceLabel: 'Package Price:',
      creditsIncludedLabel: 'Credits Included:',
      creditsCount: '{{formattedCount}} credits',
      creditsCount_one: '{{formattedCount}} credit',
      creditsCount_other: '{{formattedCount}} credits',
      costPerCreditLabel: 'Cost per 1,000 credits:',
      saveBadge: 'Save {{value}}%',
      bestValueBadge: 'Best Value',
      share: 'Share checkout link',
      copyLink: 'Copy checkout link',
      priceLabel: 'Price',
      priceIdLabel: 'Price ID',
      monthlyEquivalent: '~{{price}}/mo',
      status: {
        active: 'Active',
        draft: 'Draft',
        archived: 'Archived',
      },
    },
    
    // Billing Cycles Configuration  
    billingCyclesConfiguration: 'Billing Cycles Configuration',
    manageBillingCyclesDescription: 'Configure the available billing cycles for this product',
    availableBillingCycles: 'Available Billing Cycles',
    customBillingCycles: 'Custom Billing Cycles',
    selectAtLeastOneCycle: 'Select at least one billing cycle',
    addCustomCycle: 'Add Custom Cycle',
    cycleName: 'Cycle Name',
    lengthInMonths: 'Length in Months',
    discountPercentage: 'Discount Percentage',
    deleteCycle: 'Delete Cycle',
    createCustomCycle: 'Create custom billing cycle',
    cycleNamePlaceholder: 'e.g., Quarterly',
    saveBillingCycles: 'Save Billing Cycles',
    billingCycleInfo: 'The system automatically identifies the shortest billing cycle to determine how often credits reset or renew, regardless of the customer\'s payment schedule.',
    standardBillingCycles: 'Standard Billing Cycles',
    creditResetCycle: 'Credit Reset Cycle',
    everyXMonths: 'Every {{count}} month',
    everyXMonths_plural: 'Every {{count}} months',
    addCustom: 'Add Custom',
    noCustomCyclesConfigured: 'No custom cycles configured',
    automaticCreditResetCycle: 'Automatic Credit Reset Cycle',
    creditsWillResetInfo: 'Credits will reset or renew every {{count}} month, regardless of the customer\'s chosen payment schedule.',
    creditsWillResetInfo_plural: 'Credits will reset or renew every {{count}} months, regardless of the customer\'s chosen payment schedule.',
    addCustomBillingCycle: 'Add Custom Billing Cycle',
    createCustomBillingCycleDescription: 'Create a custom billing cycle for your product',
    durationMonths: 'Duration (months)',
    addCycle: 'Add Cycle',
    
    // Credit Management Settings
    creditManagementSettings: 'Credit Management Settings',
    configureCreditSettings: 'Configure how credits are managed for this product',
    basePricePerCredit: 'Base price per credit',
    autoTopUpSettings: 'Auto Top-up Settings',
    enableAutoTopUp: 'Enable auto top-up',
    autoTopUpThreshold: 'Auto top-up threshold',
    autoTopUpAmount: 'Auto top-up amount',
    whenCreditsDropBelow: 'When credits drop below',
    creditsToAdd: 'Credits to add',
    saveCreditSettings: 'Save Credit Settings',
    creditLifecycle: 'Credit Lifecycle',
    creditsReset: 'Credits Reset',
    creditsResetDescription: 'Credits reset at the end of each {{cycle}} billing cycle. Unused credits don\'t carry over. Simple and predictable.',
    creditsResetInfo: 'Even customers who pay annually will have their credits reset {{cycle}}.',
    creditsAccumulate: 'Credits Accumulate',
    creditsAccumulateDescription: 'Credits carry over between billing cycles. Provides flexibility for variable usage patterns.',
    creditsExpireAfter: 'Credits expire after',
    billingCyclesText: 'billing cycles ({{cycle}})',
    fifoInfo: 'Uses FIFO (First In, First Out) - oldest credits expire first',
    accountingImpact: 'Accounting Impact',
    accumulatedCreditsInfo: 'Accumulated credits create financial liability. Track this in Settings → Credit Liability Accounting.',
    
    // Billing Configuration Form
    configureBillingSettingsDescription: 'Configure payment methods, trials, and billing automation for your product',
    paymentMethods: 'Payment Methods',
    selectAcceptedPaymentMethods: 'Select which payment methods your customers can use',
    trialPeriodSettings: 'Trial Period Settings',
    configureTrialPeriodDescription: 'Configure free trial options for new customers',
    enableTrialPeriod: 'Enable trial period',
    trialPeriodDuration: 'Trial period duration',
    days: 'days',
    requirePaymentMethodForTrial: 'Require payment method for trial',
    trialPeriodInfo: 'Customers will have full access during the trial period. No charges will be made until the trial expires.',
    billingAutomation: 'Billing Automation',
    configureBillingAutomationDescription: 'Configure automated billing processes',
    enableAutomaticCharging: 'Enable automatic charging',
    invoiceSettings: 'Invoice Settings',
    customizeInvoiceSettingsDescription: 'Customize how invoices are generated and sent to customers',
    sendInvoiceEmails: 'Send invoice emails automatically',
    invoiceFooter: 'Invoice footer text',
    invoiceFooterPlaceholder: 'Add custom footer text that appears on all invoices',
    invoiceMemo: 'Invoice memo',
    invoiceMemoPlaceholder: 'Add a memo that appears on invoices',
    taxSettings: 'Tax Settings',
    configureTaxSettingsDescription: 'Configure tax calculation and display options',
    enableTaxCalculation: 'Enable tax calculation',
    defaultTaxRate: 'Default tax rate',
    taxInclusivePricing: 'Tax-inclusive pricing',
    dunningConfiguration: 'Dunning Configuration',
    configureDunningDescription: 'Configure how failed payments are handled',
    unsavedConfigurationChanges: 'You have unsaved changes to your billing configuration',
    billingConfigurationCreated: 'Billing configuration created successfully',
    billingConfigurationUpdated: 'Billing configuration updated successfully',
    billingCycleAdded: 'Billing cycle added successfully',
    billingCycleRemoved: 'Billing cycle removed successfully',
    customBillingCycleCreated: 'Custom billing cycle created successfully',
    customBillingCycleRemoved: 'Custom billing cycle removed successfully',
    
    // Customer Preview
    customerPreview: 'Customer Preview',
    customerPreviewDescription: 'See how your billing options will appear to customers',
    previewLabel: 'Preview',
    chooseYourPlan: 'Choose your plan:',
    selectLabel: 'Select',
    purchaseCredits: 'Purchase credits:',
    saveButtonLabel: 'Save',
    oneTimeOption: 'One-time Purchase',
    noBillingModelSelected: 'Please select at least one billing model to see the customer preview',
    purchaseNow: 'Purchase Now',
    oneTimePaymentForLifetime: 'One-time payment for lifetime access',
    yourApiProduct: 'Your API Product',
    
    // Categories
    paymentCategoryLabel: 'Payment',
    analyticsCategoryLabel: 'Analytics',
    
    // Status
    production: 'Production',
    staging: 'Staging',
    
    // Actions
    addNewProduct: 'Add New Product',
    manageApis: 'Manage APIs',
    viewDetails: 'View Details',
    updateProduct: 'Update Product',
    
    // Feature Flags
    featureFlagsAllowControl: 'Feature flags allow you to control which features are available to your customers',
    featureFlagsDescription: 'Control feature availability for your customers',
    addFeatureFlag: 'Add Feature Flag',
    noFeatureFlagsYet: 'No feature flags yet',
    noFeatureFlagsFound: 'No feature flags found',
    addFeatureFlagTitle: 'Add Feature Flag',
    createFeatureFlag: 'Create a new feature flag for this product',
    editFeatureFlagTitle: 'Edit Feature Flag', 
    updateFeatureFlag: 'Update feature flag settings',
    flagKey: 'Flag Key',
    flagKeyLabel: 'Flag Key',
    flagKeyPlaceholder: 'e.g., advanced-analytics',
    flagKeyHint: 'Use lowercase letters, numbers, and hyphens only. This cannot be changed after creation.',
    nameLabel: 'Display Name',
    namePlaceholder: 'e.g., Advanced Analytics Dashboard',
    featureFlagDescriptionLabel: 'Description',
    featureFlagDescriptionPlaceholder: 'Describe what this feature does...',
    roleRulesLabel: 'Role access',
    roleRulesDescription: 'Control which roles can access or toggle this feature flag.',
    roleRulesEmptyHint: 'No rules means every role is allowed.',
    roleRulesBucketHint: 'Add role rules or leave empty to allow all roles.',
    roleRulesAllRoles: 'All roles allowed',
    roleRulesProviderLabel: 'Provider roles',
    roleRulesCustomerLabel: 'Customer roles',
    roleRulesTeamLabel: 'Team roles',
    roleRulesColumnLabel: 'Access',
    addRoleRule: 'Add rule',
    selectRolePlaceholder: 'Select role',
    selectEffectPlaceholder: 'Select effect',
    roleRuleEffectAllow: 'Allow',
    roleRuleEffectDeny: 'Deny',
    removeRoleRule: 'Remove role rule',
    visibilityLabel: 'Visible to customers',
    visibility: 'Visibility',
    visible: 'Visible',
    hidden: 'Hidden',
    enabled: 'Enabled',
    disabled: 'Disabled',
    createFeatureFlagButton: 'Create Feature Flag',
    saveChanges: 'Save Changes',
    featureFlagSaveError: 'Unable to save this feature flag. Please fix the errors and try again.',
    
    // API Integration
    apiIntegration: 'API Integration',
    howToUseFeatureFlags: 'How to use feature flags in your API',
    endpoint: 'Endpoint',
    customerIdParam: 'customerId',
    responseExample: 'Response Example',
    featureFlagsApiRoute: 'GET /api/v1/customers/{{customerId}}/feature-flags',
    activeFeatures: 'activeFeatures',
    salesOrderId: 'salesOrderId',
    effectiveDate: 'effectiveDate',
    featureFlagsStoredInfo: 'Feature flags are stored and managed through your API gateway. Use the customer feature flags endpoint to check which features are enabled for each customer.',
    errors: {
      notFound: 'Product not found.',
      failedToLoadEndpoints: 'Failed to load endpoints.',
    },
  } as const;

export default products;
